import React from 'react';

const UnsubscribeTest = () => {
  console.log('UnsubscribeTest component loaded');
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <h1>Unsubscribe Test Page</h1>
      <p>This is a test page to check if the route is working.</p>
      <p>If you can see this, the route is working correctly.</p>
    </div>
  );
};

export default UnsubscribeTest;
